import React from 'react'
import {Box, Flex, Heading, Text, Link, StyledOcticon, Flash} from '@primer/components'
import {MarkGithub} from '@githubprimer/octicons-react'
import ButtonGreen from './ButtonGreen.js'
import HeroImage from './Image.js'
import InterHeading from './InterHeading.js'

const Hero = ({
  href,
  title,
  desc,
  link
}) => (
    <Box px={3} bg="gray.1" pb={8}>
      <Box py={6} maxWidth="1280px" mx={"auto"}>
        <Link href={href} color="black">
          <Flex alignItems="center">
            <StyledOcticon color="black" icon={MarkGithub} size="28" />
            <Heading fontFamily="mono" fontWeight={400} fontSize={2} pl={3} mt={1}>
            Customer Experience Research
            </Heading>
          </Flex>
        </Link>

        <Flex flexWrap={["wrap", "wrap", "wrap", "noWrap"]} pb={6}>
          <Flex.Item as={Box} width={[1, 1, 1, 1/2]} ml={[0,'44px']} pr={[0, 8]}>
            <InterHeading mt={8} mb={4} fontSize={[6,'56px']} fontWeight="600" lineHeight={1.25}>
            {title}
            </InterHeading>
            <Text mb={6} as="p" color="gray.6" fontSize={[2, 2, 3]}>
            {desc}
            </Text>
            <ButtonGreen href={link}>
             Sign up to participate →
           </ButtonGreen>
          </Flex.Item>
          <Flex.Item as={Box} width={[1, 1, 8/10, 1/2]} mx="auto" alignSelf="flex-end" mb={-3}>
            <HeroImage src="https://user-images.githubusercontent.com/334891/57001629-9a407180-6b6e-11e9-8b7c-07e8cbaf5d43.png" pt={[5, 5, 4, 0]} width="100%" />
          </Flex.Item>
        </Flex>
      </Box>
    </Box>
  )

export default Hero 
